"use client";

import { c as _c } from "react/compiler-runtime";
import { memo } from "react";
interface UnreadDividerProps {
  readonly label?: string | undefined;
}
const UnreadDivider = memo(function UnreadDivider(t0) {
  const $ = _c(6);
  const {
    label: t1
  } = t0;
  const label = t1 === undefined ? "New Messages" : t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="tw-flex-1 tw-h-0.5 tw-bg-rose-500" />;
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  let t3;
  if ($[1] !== label) {
    t3 = <span className="tw-text-xs tw-font-semibold tw-text-rose-500 tw-whitespace-nowrap">{label}</span>;
    $[1] = label;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <div className="tw-flex-1 tw-h-0.5 tw-bg-rose-500" />;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== t3) {
    t5 = <div className="tw-flex tw-items-center tw-gap-3 tw-py-0.5 tw-px-2">{t2}{t3}{t4}</div>;
    $[4] = t3;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  return t5;
});
export default UnreadDivider;